import React from 'react';
import classNames from './style.module.scss';

interface NotificationBellProps {
	notifications: number;
	onClick: () => void;
}

const NotificationBell: React.FC<NotificationBellProps> = ({
	notifications,
	onClick,
}) => {
	return (
		<button className={classNames.notificationBell} onClick={onClick}>
			<i className="bi bi-chat-left-dots-fill"></i>

			<div className={classNames.notificationBellBadge}>{notifications}</div>
		</button>
	);
};

export default NotificationBell;
